﻿<template>
  <div v-if="context.show" class="modal-mask" style="z-index: 9999">
    <div class="modal-wrapper">
      <div class="modal-container align-center">
        <span class='ca-modal-warning'>
          <img class="ca-modal__warning" src="/ui/svg/ico-error-full.svg" />
        </span>
        <br/>
        <br/>
        <div class="modal-header">
        </div>
        <div class="modal-body">
          <span>{{context.message}}</span>
        </div>
        <div class="modal-footer">
            <button class="modal-default-button-single" v-on:click="close">
              OK
            </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
  name: 'ca-popup-message',
  props: ['context'],
  methods: {
  close: function () {
  this.$store.dispatch('hidePopupMessage');
  }
  },
  }
</script>